import { render, staticRenderFns } from "./MemberScore.vue?vue&type=template&id=6f90c5a8&scoped=true&"
import script from "./MemberScore.vue?vue&type=script&lang=js&"
export * from "./MemberScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90c5a8",
  null
  
)

export default component.exports